import ApiService from "@/services/ApiService";
import UserService from "@/services/UserService";
import AppFlow from "../AppFlow";
let currentRegistrationId;
let currentFlow = "PREPAID_CARD";

class RegistrationService {
  setCurrentRegistrationId(id) {
    currentRegistrationId = id;
    sessionStorage.setItem("cr_regId", id);
  }
  getCurrentRegistrationId() {
    const id = currentRegistrationId
      ? currentRegistrationId
      : sessionStorage.getItem("cr_regId");
    return id ? id : "me";
  }
  removeCurrentRegistrationId() {
    currentRegistrationId = null;
    sessionStorage.removeItem("cr_regId");
  }

  setIsTutor(value) {
    sessionStorage.setItem("cr_isTutor", value);
  }
  isTutor() {
    return sessionStorage.getItem("cr_isTutor") !== null;
  }
  removeIsTutor() {
    sessionStorage.removeItem("cr_isTutor");
  }

  setCurrentFlow(flow, isMinor) {
    let f = flow;
    if (this.isTutor()) {
      f = "TUTOR";
    } else if (isMinor) {
      f = "PREPAID_CARD_MINOR";
    }
    currentFlow = f;
    AppFlow.setStepsFlow(f);
  }
  getCurrentFlow() {
    return currentFlow;
  }

  addTracking(req) {
    return ApiService.post(
      `/usr/v2/registrations/${this.getCurrentRegistrationId()}/tracking`,
      req
    );
  }

  updateRegistration(req) {
    return ApiService.post(
      `/usr/v2/registrations/${this.getCurrentRegistrationId()}/update`,
      req
    );
  }

  upgradeVirtualCard(req) {
    return ApiService.post(`/usr/v2/registrations/upgrade-virtual-card`, req);
  }

  upgradeRegistrationProgress(step) {
    console.log("*** UPGRADING STEP TO [" + step + "]");
    const flow = currentFlow === "TUTOR" ? "PREPAID_CARD_MINOR" : currentFlow;
    return ApiService.post(
      `/usr/v2/registrations/${this.getCurrentRegistrationId()}/update-registration-progress`,
      {
        flow,
        step
      }
    );
  }

  /**
   * Prepaid Card Registration Status
   * active:   process started
   * pending:  registration flow completed, waiting for COMdata approval
   * closed:   process completed
   **/
  prepaidCardRequestIsStarted(reg) {
    reg
      ? reg.active
      : this.getMyRegistrations().then(registration =>
          registration && registration.active ? registration.active : null
        );
  }
  prepaidCardRequestIsPending(reg) {
    reg
      ? reg.pending
      : this.getMyRegistrations().then(registration =>
          registration && registration.pending ? registration.pending : null
        );
  }
  prepaidCardRequestIsComplete(reg) {
    reg
      ? reg.closed
      : this.getMyRegistrations().then(registration =>
          registration && registration.closed ? registration.closed : null
        );
  }

  hasPrepaidCardPendingRequest() {
    this.getMyRegistrations().then(reg => {
      return reg && (reg.pending || reg.started);
    });
  }

  getUserPresale() {
    return new Promise(resolve => {
      ApiService.get(`/bill/v2/presale-users/me`).then(
        response => {
          const presaleExists = !!response.data;
          const presaleIsValid = response?.data?.status === "CONFIRMED";
          if (presaleExists && presaleIsValid) {
            const presale = response.data;
            ApiService.get(`/usr/v2/plans/${presale.planId}`).then(
              plan => {
                presale.plan = plan.data;
                resolve(presale);
              },
              () => {
                resolve(null);
              }
            );
          } else {
            resolve(null);
          }
        },
        () => {
          resolve(null);
        }
      );
    });
  }

  async userHasInfluencerPresale() {
    const presale = await this.getUserPresale();
    const presaleInfluencer = presale?.plan?.type === "INFLUENCER";
    return presaleInfluencer;
  }

  async userIsRequestingInfluencerCard() {
    const vm = window.vm;

    if (!vm.$store?.state?.registrations) {
      await this.getMyRegistrations();
    }
    return (
      vm.$store?.state?.registrations?.prepaidCardResource?.profile ===
      "INFLUENCER"
    );
  }

  async userSubscribedAnyPlan() {
    const getUserSubscriptions = await UserService.getUserSubscriptions();
    //This will check if user has subscribed any plan.
    //Do we want to check if he subscribed the influencer card plan?
    const userAlreadySubscribed = getUserSubscriptions.data.length > 0;
    return userAlreadySubscribed;
  }

  getMyRegistrations() {
    return new Promise((resolve, reject) => {
      const vm = window.vm;
      ApiService.get(
        `/usr/v2/registrations/${this.getCurrentRegistrationId()}`
      ).then(
        response => {
          let currentRegistration;
          let registrations = response.data.registration
            ? [response.data.registration]
            : response.data.registrations;

          if (registrations) {
            currentRegistration = registrations.filter(reg => {
              //the "closed" field is computed at BE and returns true if registration is COMPLETED or CANCELED or other completed statuses
              const isClosed = reg.closed;
              const isTypeRegistration = reg.type === "PREPAID_CARD";
              const allowedFlows =
                reg.flow === "PREPAID_CARD" ||
                reg.flow === "PREPAID_CARD_MINOR";

              return allowedFlows && isTypeRegistration && !isClosed;
            })[0];
          } else if (
            (response.data.lastRegistration.flow === "PREPAID_CARD" ||
              response.data.lastRegistration.flow === "PREPAID_CARD_MINOR") &&
            !response.data.lastRegistration.closed
          ) {
            currentRegistration = response.data.lastRegistration;
          }

          if (!currentRegistration) {
            console.log("No registrations found");
            resolve(null);
            return;
          }
          const oldRegistrationId = this.getCurrentRegistrationId();

          this.setCurrentRegistrationId(currentRegistration.id);
          const isMinor = response.data?.user?.minor || false;
          this.setCurrentFlow(currentRegistration.flow, isMinor);

          console.log("---------- RECOVERING DATA ----------");
          vm.$store.commit("setRegistrations", currentRegistration);
          vm.$store.commit("setUser", response.data.user);
          console.log("-------------------------------------");

          console.log("------------ CURRENT FLOW ------------");
          console.log(currentFlow);
          console.log("--------------------------------------");

          //when calling with "me" instead of id, the registration object will contains less data
          //so we call again this function, but this time it will use the specific id, now that we know it
          if (oldRegistrationId === "me") {
            resolve(this.getMyRegistrations());
          } else {
            resolve(currentRegistration);
          }
        },
        error => {
          reject(error);
        }
      );
    });
  }

  startPrepaidCardRequest(req) {
    return ApiService.post(
      `/usr/v2/registrations/me/start-prepaid-card-request`,
      req
    );
  }

  selectCard(req) {
    return ApiService.post(
      `/usr/v2/registrations/${this.getCurrentRegistrationId()}/select-card`,
      req
    );
  }

  saveAddresses(req) {
    return ApiService.post(
      `/usr/v2/registrations/${this.getCurrentRegistrationId()}/addresses`,
      req
    );
  }

  saveDocuments(req) {
    return ApiService.post(
      `/usr/v2/registrations/${this.getCurrentRegistrationId()}/documents`,
      req
    );
  }

  saveFatcaGianos(req) {
    return ApiService.post(
      `/usr/v2/registrations/${this.getCurrentRegistrationId()}/fatca-gianos`,
      req
    );
  }

  setTerms(req) {
    return ApiService.post(
      `/usr/v2/registrations/${this.getCurrentRegistrationId()}/terms`,
      req
    );
  }

  saveDocumentScans(req) {
    return ApiService.post(
      `/usr/v2/registrations/${this.getCurrentRegistrationId()}/document-scans`,
      req
    );
  }

  sendConfirmationEmail() {
    return ApiService.post(
      `/usr/v2/registrations/${this.getCurrentRegistrationId()}/send-confirmation-email`
    );
  }

  sendPhoneNumberOtp() {
    return ApiService.post(
      `/usr/v2/registrations/${this.getCurrentRegistrationId()}/send-phone-number-otp`
    );
  }

  modifyEmail(req) {
    return ApiService.post(
      `/usr/v2/registrations/${this.getCurrentRegistrationId()}/modify-email`,
      req
    );
  }

  checkMgmCode(code) {
    return ApiService.get(`/usr/v2/registrations/check-mgm/${code}`);
  }

  /** ************* INFOCERT ************ */
  createDossier(req) {
    return ApiService.post(
      `/usr/v2/registrations/${this.getCurrentRegistrationId()}/infocert/dossiers`,
      req
    );
  }
  startDossier(req) {
    return ApiService.post(
      `/usr/v2/registrations/${this.getCurrentRegistrationId()}/infocert/dossiers/start`,
      req
    );
  }
  signAndAssertAuth(req) {
    return ApiService.post(
      `/usr/v2/registrations/${this.getCurrentRegistrationId()}/infocert/dossiers/sign-and-assert-auth`,
      req
    );
  }
  getInforcertTerms(req) {
    return ApiService.get(
      `/usr/v2/registrations/${this.getCurrentRegistrationId()}/infocert/dossiers/terms`,
      req
    );
  }
  acceptClauses(req) {
    return ApiService.post(
      `/usr/v2/registrations/${this.getCurrentRegistrationId()}/infocert/dossiers/accept-clauses`,
      req
    );
  }

  issueAndSign(req) {
    return ApiService.post(
      `/usr/v2/registrations/${this.getCurrentRegistrationId()}/infocert/dossiers/issue-and-sign`,
      req
    );
  }

  sign(req) {
    return ApiService.post(
      `/usr/v2/registrations/${this.getCurrentRegistrationId()}/infocert/dossiers/one-step-sign`,
      req
    );
  }

  getSignatureStatus(req) {
    return ApiService.get(
      `/usr/v2/registrations/${this.getCurrentRegistrationId()}/infocert/dossiers/sign-status`,
      req
    );
  }

  sendOtp(req) {
    return ApiService.post(
      `/usr/v2/registrations/${this.getCurrentRegistrationId()}/infocert/dossiers/send-signature-otp`,
      req
    );
  }

  userHasValidCertificate(userId) {
    const id = userId || this.getCurrentRegistrationId();
    return new Promise((resolve, reject) => {
      ApiService.get(
        `/usr/v2/registrations/${id}/infocert/certificate-status`
      ).then(
        response => {
          resolve(response.data.status === "VALID");
        },
        error => {
          reject(error);
        }
      );
    });
  }

  setTutor(req) {
    return ApiService.post(
      `/usr/v2/registrations/${this.getCurrentRegistrationId()}/set-tutor`,
      req
    );
  }

  asTutor(req) {
    return ApiService.get(`/usr/v2/registrations/as-tutor`, req);
  }

  requestCard(req) {
    return ApiService.post(
      `/usr/v2/registrations/${this.getCurrentRegistrationId()}/request-card`,
      req
    );
  }
}

export default new RegistrationService();
